module.exports = __webpack_public_path__ + "static/img/ino_2018_autumn.3843b18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ino_2018_autumn.jpg
// module id = CBTI
// module chunks = 0